import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useAppDispatch, useSelector } from 'rahtab-redux';
import { addMerchandiseOrdering, orderingMerchandiseSelector } from 'rahtab-redux/slices/merchandiseOrderingSlice';
import { addMerchandise } from 'rahtab-redux/slices/merchandisesSlice';
import { useState } from 'react';
function useMerchandises(config: UseMerchandisesData) {
  const { categoryId } = config;
  const [idsList, setIdsList] = useState<Set<string> | undefined>();
  const dispatch = useAppDispatch();
  const merchandiseList = useSelector(orderingMerchandiseSelector(Array.from(idsList?.values() || [])));
  const [refetch, { data, loading, called, ...result }] = useFetchCallType<OfferTemplateInfo[]>(
    'GetOfferTemplateList',
    {
      params: `ProductCode=${categoryId}`,
      onCompleted: (d) => {
        const temp = new Set(idsList);

        for (const offer of d) {
          temp.add(offer.TemplateCode);
          dispatch(addMerchandiseOrdering(offer));
          dispatch(addMerchandise({ ...offer, MeasureName: '' }));
        }
        setIdsList(temp);
      },
    },
  );
  return {
    data: merchandiseList,
    loading,
    called,
    ...result,
    refetch,
  };
}

export default useMerchandises;

interface UseMerchandisesData {
  categoryId: string;
}

// eslint-disable-next-line no-shadow
export enum OrderingType {
  DAILY = '1',
  PERIODIC = '2',
}

export interface OfferTemplateInfo {
  TemplateCode: string;
  TemplateName: string;
  TemplateImage: string;
  CommentCount: string;
  Status: string;
  StatusCode: number;
  SupplierCount: string;
  OfferAmount: string;
  TemplateDeliveryDate: string;
  OrderingType: OrderingType;
}
